@let collapsed = isCollapsed ;
@let collapsedDelayed = isCollapsedDelayed ;

@if (item.link) {
  <mat-list>
    <ng-container *ngTemplateOutlet="interactableWithHighlighting context: { item: item }"/>
  </mat-list>
} @else if (!item.link && isFloating(item)) {
  <mat-list>
    <ng-container *ngTemplateOutlet="interactableWithFloating context: { item: item, collapsed: collapsed || collapsedDelayed }"/>
  </mat-list>
} @else {
  @if (item.text && !item.link) {
    @if (collapsed || collapsedDelayed) {
      <div class="module__divider-hit-box--collapsed" [matTooltip]=item.text matTooltipShowDelay="200" matTooltipPosition="right">
        <hr class="module__divider--collapsed">
      </div>
    } @else {
      <span class="section-name mat-label-large">{{ item.text | uppercase }}</span>
    }
  }
  <mat-list>
    @for (section of item.items; track $index) {
      <div #hoverRef>
        <ng-container *ngTemplateOutlet="interactableWithHighlighting context: { item: section }"/>
      </div>

      @if (!isCollapsed) {
        @if (section.items) {
          <mat-list class="collapsable" [class.selected]=isSelected(section)>
            @for (item of section.items; track $index) {
              <ng-container *ngTemplateOutlet="interactableWithFloating context: { item: item }"/>
            }
          </mat-list>
        }
      } @else {
        <div class="floating-container" appFloating [triggerRef]="hoverRef"
             [parentDestroyRef]="destroyRef" triggerMode="click" [hoverCloseDelay]="section.items ? 1200 : 200">
          <ng-container *ngTemplateOutlet="interactableWithHighlighting context: { item: section, isHeader: true}"/>
          @if (section.items) {
            <mat-list class="floating floating-header" [class.selected]=isSelected(section)>
              @for (item of section.items; track $index; let sectionItemLast = $last) {
                @let accordionSelected = item.id === selectedAccordion()?.id ;
                <div (click)="selectAccordion(item)">
                  <ng-container
                    *ngTemplateOutlet="interactable context: {item: item, additionalIcon: accordionSelected ? 'chevron-up' : 'chevron-down'}"/>
                </div>
                <mat-list class="collapsable indented" [class.selected]=accordionSelected>
                  @for (subItem of item.items; track $index; let outerLast = $last) {
                    @for (subSubItem of subItem.items; track $index; let innerLast = $last) {
                      <ng-container *ngTemplateOutlet="interactable context: { item: subSubItem }"/>
                      @if (accordionSelected && innerLast && !outerLast) {
                        <hr/>
                      }
                    }
                  }
                </mat-list>
                @if (!accordionSelected && !sectionItemLast) {
                  <hr/>
                }
              }
            </mat-list>
          }
        </div>
      }
    }
  </mat-list>
}

<ng-template #interactable let-item="item" let-additionalIcon="additionalIcon" let-collapsed="collapsed">
  <mat-list-item class="sidebar-list-item mat-mdc-list-item-interactive"
                 [class.accordion-selected]="item.id === selectedAccordion()?.id"
                 [matTooltip]="resolveTooltip(item)"
                 matTooltipPosition="right"
                 [matTooltipShowDelay]="200"
                 [disabled]="isDisabled(item)"
                 [routerLink]="!isDisabled(item) ? resolveUrl(item): undefined"
                 (click)="onExtjsAction(item.action)">
    <app-core-sidebar-list-item [icon]="item.icon" [name]="item.text" [collapsed]="collapsed"
                                [additionalIcon]="item.additionalIcon ?? (additionalIcon === 'auto' ? 'chevron-right' : additionalIcon)"/>
  </mat-list-item>
</ng-template>

<ng-template #interactableWithHighlighting let-item="item" let-isHeader="isHeader">
  <mat-list-item class="section-item sidebar-list-item mat-mdc-list-item-interactive"
                 [class.header]="isHeader ?? false"
                 [class.selected]="isSelected(item)"
                 [matTooltip]="resolveTooltip(item)"
                 matTooltipPosition="right"
                 [matTooltipShowDelay]="200"
                 [disabled]="isDisabled(item)"
                 [routerLink]="!isDisabled(item) ? resolveUrl(item): undefined">
    @if (isHeader) {
      <app-core-sidebar-list-item [name]="item.text"/>
    } @else {
      <app-core-sidebar-list-item [collapsed]="collapsed || collapsedDelayed" [icon]="item.icon" [name]="item.text"
                                  [additionalIcon]="item.additionalIcon"/>
    }
  </mat-list-item>
</ng-template>

<ng-template #interactableWithFloating let-item="item" let-collapsed="collapsed">
  <div #hoverRef>
    <ng-container *ngTemplateOutlet="interactable context: { item: item, additionalIcon: 'auto', collapsed: collapsed }"/>
  </div>
  @if (item.items && !isDisabled(item)) {
    <mat-list appFloating [triggerRef]="hoverRef" [parentDestroyRef]="destroyRef" triggerMode="click">
      @for (subItem of item.items; track $index; let outerLast = $last) {
        @for (subSubItem of subItem.items; track $index; let innerLast = $last) {
          <ng-container *ngTemplateOutlet="interactable context: { item: subSubItem }"/>
          @if (innerLast && !outerLast) {
            <hr/>
          }
        }
      }
    </mat-list>
  }
</ng-template>
